import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import RichTextEditor from "react-rte";
import { tokens } from "styles/Tokens";
import Typography from "./Typography";
interface Props {
  label?: string;
  initialValue: any;
  placeholder?: string;
  handleChangeUpdate: (val: any) => void;
  minHeight?: string;
}

export default function RichText(props: Props) {
  const { label, initialValue, placeholder, handleChangeUpdate, minHeight } = props;
  const [val, setVal] = useState({ value: RichTextEditor.createEmptyValue() });
  const handleChange = (value: any) => {
    setVal({ value });
    handleChangeUpdate(value.toString("html"));
  };
  useEffect(() => {
    const value = RichTextEditor.createValueFromString(initialValue, "html");
    setVal({ value });
  }, []);
  const toolbarConfig: any = {
    // Optionally specify the groups to display (displayed in the order listed).
    display: ["INLINE_STYLE_BUTTONS", "BLOCK_TYPE_BUTTONS", "LINK_BUTTONS"],
    INLINE_STYLE_BUTTONS: [
      { label: "Bold", style: "BOLD", className: "custom-css-class" },
      { label: "Italic", style: "ITALIC" },
      { label: "Underline", style: "UNDERLINE" }
    ],

    BLOCK_TYPE_BUTTONS: [
      { label: "UL", style: "unordered-list-item" },
      { label: "OL", style: "ordered-list-item" }
    ]
  };

  return (
    <>
      <Box width="100%" textAlign="left">
        {label && (
          <>
            <Typography component="span" variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              {label}
            </Typography>
          </>
        )}
        <Grid textAlign="left">
          <RichTextEditor
            rootStyle={{ minHeight: minHeight ?? "none" }}
            className="text-editor rich-text-root"
            toolbarConfig={toolbarConfig}
            placeholder={placeholder}
            value={val.value}
            onChange={handleChange}
          />
        </Grid>
      </Box>
    </>
  );
}
